import debounce from 'lodash/debounce';

import { readTableRouteState, writeTableRouteParams, type TableRouteState } from './table-routing';

export const createRouteSync = (prefix: string, filterKeys: string[]) => {
  const read = (defaults: { page: number; pageSize: number }): TableRouteState =>
    readTableRouteState(window.location.search, prefix, filterKeys, defaults);

  const push = (state: TableRouteState) => {
    const url = new URL(window.location.href);
    url.search = writeTableRouteParams(url.searchParams, prefix, state, filterKeys).toString();
    window.history.pushState({}, '', url);
  };

  const writeDebounced = debounce(push, 400);

  const write = (state: TableRouteState) => {
    writeDebounced.cancel();
    push(state);
  };

  return { read, write, writeDebounced };
};

export type RouteSync = ReturnType<typeof createRouteSync>;
